import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type CardStatusTone = 'error' | 'warning' | 'info' | 'success' | 'neutral';

// Full class names, so Tailwind generates them.
const CARD_STATUS_TEXT: Record<CardStatusTone, string> = {
  error: 'text-error',
  warning: 'text-warning',
  info: 'text-info',
  success: 'text-success',
  neutral: 'text-primary'
};
type CardStatusProps = {
  tone: CardStatusTone;
  children: ReactNode;
};

/** A card's result as colored text, in its title strip. */
const CardStatus = t0 => {
  const $ = _c(5);
  const {
    tone,
    children
  } = t0;
  const t1 = CARD_STATUS_TEXT[tone];
  let t2;
  if ($[0] !== t1) {
    t2 = cx("shrink-0 text-label-3", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <span className={t2}>{children}</span>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export type { CardStatusTone };
export { CARD_STATUS_TEXT };
export default CardStatus;